import { render, staticRenderFns } from "./item-disapproved.vue?vue&type=template&id=844a0378&scoped=true&"
import script from "./item-disapproved.vue?vue&type=script&lang=js&"
export * from "./item-disapproved.vue?vue&type=script&lang=js&"
import style0 from "./item-disapproved.vue?vue&type=style&index=0&id=844a0378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844a0378",
  null
  
)

export default component.exports